import { KEYCODES } from "@/scripts/helpers/constants";

const dropdownAction = $(".js-formats-dropdown-action");
const dropdown = dropdownAction.parent(".formats-dropdown");

const updateActionText = (element, text) => {
  element.text(text);
};

const closeDropdown = () => {
  dropdown.removeClass("is-active");
};

const setActiveItem = dropdownItem => {
  const radio = dropdownItem.find(".formats-item__radio");

  radio.each(function() {
    const item = $(this)
      .parent()
      .parent();

    if ($(this).is(":checked")) {
      item.addClass("is-active");
    } else {
      item.removeClass("is-active");
    }
  });
};

export const setActiveStateOnModalOpen = () => {
  $(".js-choose-state-button").on("click", () => {
    const currentStateText = $(".state__value").text();
    const dropdownStateLabelsSelector = $(
      ".modal--choose-state .formats-item__body"
    );
    const changeStateSelector = $(".js-update-state");

    dropdownStateLabelsSelector.each(function() {
      const dropdownStateText = $(this).text();
      const dropdownStateInput = $(this).prev();
      const currentItem = $(this)
        .parent()
        .parent();

      if (currentStateText == dropdownStateText) {
        currentItem.addClass("is-active");
        dropdownStateInput.prop("checked", "checked");
        changeStateSelector.attr("href", dropdownStateInput.val());
        $(".modal--choose-state .formats-dropdown__action-body").text(
          currentStateText
        );
        $(".modal--choose-state .formats-native-dropdown__body").text(
          currentStateText
        );
      } else {
        currentItem.removeClass("is-active");
        dropdownStateInput.prop("checked", false);
      }
    });
  });
};

const setInitialFormat = () => {
  dropdown.each(function() {
    const firstFormatText = $(this)
      .find(".formats-item:first-child .formats-item__body")
      .text();

    const firstRadio = $(this).find(
      ".formats-item:first-child .formats-item__radio"
    );

    firstRadio.prop("checked", "checked");

    updateActionText(
      $(this).find(".formats-dropdown__action-body"),
      firstFormatText
    );
    setActiveItem($(this));
  });
};

const updateSelectedFormat = dropdownItem => {
  const checkedSelector = dropdownItem.find(".formats-item__radio:checked");
  if (checkedSelector.length) {
    const selectedFormat = dropdownItem
      .find(".formats-item__radio:checked ~ .formats-item__body")
      .text();
    updateActionText(
      dropdownItem.find(".formats-dropdown__action-body"),
      selectedFormat
    );
    setActiveItem(dropdownItem);
    closeDropdown();
  }

  return false;
};

// if 2 files using initFormatsDropdown - add custom class in pug mixin and SAME modifier to initFormatsDropdown
export const initFormatsDropdown = (
  onChangeCallback = () => false,
  modifier = ""
) => {
  setInitialFormat();
  let isModifier = false;
  const formatsDropdownActionSelector = $(".js-formats-dropdown-action");

  const initUpdateSelectedFormat = onChangeCallback => {
    $(document)
      .off("change")
      .on("change", ".formats-item__radio", function(e) {
        e.stopPropagation();
        updateSelectedFormat($(this).parents(".formats-dropdown"));
        onChangeCallback($(this));
      });
  };

  const keydownHandler = onChangeCallback => {
    $(document)
      .off("keydown")
      .on("keydown", ".formats-item", function(e) {
        const { SPACE, ENTER } = KEYCODES;

        e.stopPropagation();

        if (e.keyCode === SPACE || e.keyCode === ENTER) {
          e.preventDefault();

          if ($(".formats-item__radio").length) {
            const radio = $(this).find(".formats-item__radio");
            if (radio.is(":checked")) {
              radio.prop("checked", false);
            } else {
              radio.prop("checked", "checked");
            }

            updateSelectedFormat($(this).parents(".formats-dropdown"));
            onChangeCallback(radio);
          }
        }
      });
  };

  formatsDropdownActionSelector.each(function(idx, elem) {
    if ($(elem).hasClass(modifier)) {
      isModifier = true;
    }
  });

  if (isModifier) {
    const modifierElementSelector = $(`.${modifier}`);
    modifierElementSelector.each(function(idx, elem) {
      $(elem).on("click", function() {
        const dropdown = $(this).parent(".formats-dropdown");
        dropdown.toggleClass("is-active");
        initUpdateSelectedFormat(onChangeCallback);
        keydownHandler(onChangeCallback);
      });
    });
    return false;
  }

  $(formatsDropdownActionSelector).each(function(idx, elem) {
    $(elem).on("click", function() {
      const dropdown = $(this).parent(".formats-dropdown");
      dropdown.toggleClass("is-active");
      initUpdateSelectedFormat(onChangeCallback);
      keydownHandler(onChangeCallback);
    });
  });
};
